import './Loader.css';

const Loader = () => {
  return (
    <div className='Container'>
      <div className='Loader'></div>
    </div>
  );
};

export default Loader;
